import { createContext } from "react";

export const NotificationCountContext = createContext<number | undefined>(undefined);
